import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import AboutUs from "../pages/customerComponents/AboutUs";
import ContactForm from "../pages/customerComponents/ContactForm";
import NotFound from "../pages/NotFound";
import ResidentialServices from "../pages/customerComponents/servicesComponents/ResidentialServices";
import CommercialServices from "../pages/customerComponents/servicesComponents/CommercialServices";
import SolarServices from "../pages/customerComponents/servicesComponents/SolarServices";
import Gallery from "../pages/customerComponents/Gallery"
import FAQ from "../pages/customerComponents/FAQ";
import RemoteLanding from "../pages/customerComponents/RemoteBusinessComponents/RemoteLanding";
import AffiliateSignup from "../pages/customerComponents/RemoteBusinessComponents/AffiliateSignup";
import SignupPage from "../pages/customerComponents/SignupPage";

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact" element={<ContactForm />} />
      <Route path="/services/residential-services" element={<ResidentialServices />} />
      <Route path="/services/commercial-services" element={<CommercialServices />} />
      <Route path="/services/solar" element={<SolarServices />} />
      <Route path="/about-us/gallery" element={<Gallery />} />
      <Route path="/about-us/faq" element={<FAQ />} />
      <Route path="/remote" element={<RemoteLanding />} />
      <Route path="/affiliate" element={<AffiliateSignup />} />
      <Route path="/signup" element={<SignupPage />} />

      {/* Catch-all Route for 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;

